export const ENV = process.env.REACT_APP_ENVIRONMENT_PP;

export const EDITOR_LINK = process.env.REACT_APP_EDITOR_URL;

export const BASE_URL = process.env.REACT_APP_BE_BASE_URL;
export const WORD_EXPORT_ENDPOINT = process.env.REACT_APP_WORD_EXPORT_ENDPOINT;

export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
